import * as React from "react";
import type { SVGProps } from "react";
const SvgCascade = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.225 3.962 17.55 6.34A2 2 0 0 1 19 8.263v9.52h2v-9.52a4 4 0 0 0-2.901-3.846L9.775 2.039zM14.55 8.34 6.225 5.962l.55-1.923 8.324 2.378a4 4 0 0 1 2.9 3.846v9.52h-2v-9.52a2 2 0 0 0-1.45-1.923M2 9.618a3 3 0 0 1 3.79-2.894l6.63 1.809A3.5 3.5 0 0 1 15 11.91v7.471a3 3 0 0 1-3.79 2.895l-6.63-1.809A3.5 3.5 0 0 1 2 17.091zm3.263-.964A1 1 0 0 0 4 9.618v7.472a1.5 1.5 0 0 0 1.105 1.448l6.632 1.808A1 1 0 0 0 13 19.381V11.91a1.5 1.5 0 0 0-1.105-1.447z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgCascade;
